export class Login {
    dsEmail: string = '';
    cdSenha: string = '';
}

export class RecSenha {
    dsRecEmail: string = '';

}

export class ViewRetornoRecSenha {
    validaSenha: boolean = false;

}
